import * as React from "react";
const SvgTranslate = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M13 5V8H9V5H6L11 0L16 5H13ZM5 9H8V13H5V16L0 11L5 6V9ZM22 11L17 6V9H14V13H17V16L22 11ZM9 17V14H13V17H16L11 22L6 17H9Z"
}));
export default SvgTranslate;
